<template>
  <div class="base_station">
    <div class="head">
      <span>编号：</span>
      <el-input placeholder="请输入基站编号" v-model="search.baseId" clearable></el-input>
      <el-button size="medium" type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
      <el-button size="medium" type="success" @click="addFun" style="margin-left:2vw;">添加基站</el-button>
    </div>
    <div class="table-list">
      <el-table :data="listData" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" prop="serialNumber" width="100"></el-table-column>
        <el-table-column label="基站编号" prop="baseId"></el-table-column>
        <el-table-column label="x坐标" prop="locationX"></el-table-column>
        <el-table-column label="y坐标" prop="locationY"></el-table-column>
        <el-table-column label="z坐标" prop="locationZ"></el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button size="mini" @click="modFun(scope.row)" type="primary">编辑</el-button>
            <el-button size="mini" @click="delFun(scope.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
    ></el-pagination>
    <!-- 弹出框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        :rules="addRules"
      >
        <el-form-item label="序号：" prop="serialNumber">
          <el-input
            v-model="addForm.serialNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="基站编号：" prop="baseId">
          <el-input
            v-model="addForm.baseId"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="x坐标：">
          <el-input
            v-model="addForm.locationX"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="y坐标：">
          <el-input
            v-model="addForm.locationY"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="z坐标：">
          <el-input
            v-model="addForm.locationZ"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return{
      //查询
      search:{
        baseId:''
      },
      groupId:'',
      //列表
      dataText:'数据加载中...',
      listData:[],
      //分页
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      //添加/修改弹出框
      dialogTitle:'',
      addFormVisible:false,
      labelPosition:'right',
      addForm:{
        id:'',
        projectId:'',
        serialNumber:'',
        baseId:'',
        locationX:'',
        locationY:'',
        locationZ:''
      },
      addRules:{
        serialNumber:[{ required: true, message: '请输入序号', trigger: 'blur' }],
        baseId:[{ required: true, message: '请输入基站编号', trigger: 'blur' }]
      },
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods:{
    //查询
    doFilter(){
      this.getData()
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    //获取数据
    getData(){
      this.dataText = '数据加载中...'
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      this.search.projectId = this.groupId
      myHttp.getEquipUwbBaseList(this.search).then(resp=>{
        console.log(resp)
        if(resp.data.code==200){
          var list = resp.data.data.pageInfo.list||[]
          this.listData = list
          this.totalItems = resp.data.data.pageInfo.total
          if(list.length==0){
            this.dataText = '暂无数据'
          }
        }else{
          this.dataText = '暂无数据'
          this.listData = []
          this.totalItems = 0
        }
      })
    },
    //添加基站
    addFun(){
      this.addFormVisible = true
      this.dialogTitle = '添加基站'
      this.addForm.id = ''
      this.addForm.serialNumber = ''
      this.addForm.baseId = ''
      this.addForm.locationX = ''
      this.addForm.locationY = ''
      this.addForm.locationZ = ''
    },
    //修改基站
    modFun(row){
      this.addFormVisible = true
      this.addForm.id = row.id
      this.dialogTitle = '修改基站'
      this.addForm.serialNumber = row.serialNumber
      this.addForm.baseId = row.baseId
      this.addForm.locationX = row.locationX
      this.addForm.locationY = row.locationY
      this.addForm.locationZ = row.locationZ
    },
    //保存
    sumbitAddRow(formName){
      var that = this
      this.addForm.projectId = this.groupId
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.addForm.id==''){
              myHttp.addEquipUwbBase(this.addForm).then(resp=>{
                if(resp.data.code=='200'){
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                }else{
                  that.$message.error(resp.data.msg)
                }
              })
            }else{
              // that.addForm.updateBy = util.session.get('user').id
              myHttp.updateEquipUwbBase(that.addForm).then(function(resp){
                if(resp.data.code=='200'){
                  that.$message.success('编辑成功')
                  that.addFormVisible = false
                  that.getData()
                }else{
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            return false;
          }
      });
    },
    /**
     * 删除
     */
    delFun(row){
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.delEquipUwbBase({
            id: row.id
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
  }
}
</script>

<style scoped>
  .base_station{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .base_station .head{
    width: 100%;
    height: 6vh;
    position: relative;
    padding: 0 1vw;
    display: flex;
    align-content: center;
    align-items: center;
    border-bottom: 1px solid #409EFF;
  }
  .table-list{
    width: 100%;
    height: calc( 100% - 12vh );
    position: relative;
  }
</style>